import { Collection } from '../Tiles/TileSet';
import { EventBuilder } from './EventBuilder';
import Core from '../Core/Core';
import { getLevelId } from '../State/reducers/level';
import { LIFE_TIME } from '../State/reducers/currency';
import { ItemIDs } from '../Config/Items';

enum GameMaps {
    MACHU_PICCHU = 'machu',
    ROME = 'rome',
    SEOUL = 'seoul',
    SCOTLAND = 'scotland',
}

// properties we already have in state (some conversion needed)
export interface IParamsFromGameState {
    activeMap: GameMaps;
    activePieceSet: Collection;
    highestLevelNumber: number;
    highestLevelID: string;
    stars: number;
    magnifyingGlassBooster: number;
    flashLightBooster: number;
    fireCrackerBooster: number;
    magnetBooster: number;
    coins: number;
    musicIsOn: number;
    soundIsOn: number;
    timeToNextLife: number;
}

// create in Tracker from these default objects
export const DefaultGameStateParams: IParamsFromGameState = {
    activeMap: GameMaps.MACHU_PICCHU,
    activePieceSet: Collection.DEFAULT,
    highestLevelNumber: 1,
    highestLevelID: 'machu-1',
    stars: 0,
    magnifyingGlassBooster: 0,
    flashLightBooster: 0,
    fireCrackerBooster: 0,
    magnetBooster: 0,
    coins: 1000,
    musicIsOn: 0,
    soundIsOn: 0,
    timeToNextLife: -1,
};

export class StateParamBuilder extends EventBuilder {
    private stateData: IParamsFromGameState = { ...DefaultGameStateParams };

    constructor() {
        super();
    }

    public setAllAdParamsFromGame() {}

    public getParams<T>(): IParamsFromGameState {
        const state = Core.store.getState();
        const { StatePlayer, StateBoosters, StateCurrency, StateSound } = state;
        return {
            ...this.stateData,
            activeMap: this.getMapId(StatePlayer.mapId),
            activePieceSet: StatePlayer.activeCollection,
            highestLevelNumber: StatePlayer.lastLevelIndex,
            highestLevelID: getLevelId(StatePlayer.lastLevelIndex),
            stars: StatePlayer.totalStars,
            magnifyingGlassBooster: [...StateBoosters.availableBoosters].filter(
                b => b === ItemIDs.HINT
            ).length,
            flashLightBooster: [...StateBoosters.availableBoosters].filter(
                b => b === ItemIDs.HIGHLIGHT
            ).length,
            fireCrackerBooster: [...StateBoosters.availableBoosters].filter(
                b => b === ItemIDs.FIRECRACKER
            ).length,
            magnetBooster: [...StateBoosters.availableBoosters].filter(b => b === ItemIDs.MAGNET)
                .length,
            coins: StateCurrency.coin,
            musicIsOn: StateSound.music ? 1 : 0,
            soundIsOn: StateSound.soundFx ? 1 : 0,
            timeToNextLife:
                !StateCurrency.ts || StateCurrency.ts === 0
                    ? DefaultGameStateParams.timeToNextLife
                    : Math.max(0, LIFE_TIME - (Date.now() - StateCurrency.ts)),
        };
    }

    public setParams(keys: Map<string, unknown>): void {
        //
    }

    private getMapId(id: string): GameMaps {
        switch (id) {
            case 'machu':
                return GameMaps.MACHU_PICCHU;
            case 'rome':
                return GameMaps.ROME;
            case 'seoul':
                return GameMaps.SEOUL;
            case 'scotland':
                return GameMaps.SCOTLAND;
            default:
                return GameMaps.MACHU_PICCHU;
        }
    }
}
